import { useState } from 'react'
import { AiOutlineHome, AiOutlineHeart, AiOutlineUsergroupAdd, AiOutlineYoutube, AiOutlineFileImage } from 'react-icons/ai'

import Home from './home/Home'
import Relation from './relation/Relation'
import Video from './video/Video'
import Gallery from './gallery/Gallery'
import Friend from './friend/Friend'
import Modal from './modal/Modal'

import './content.css'
import UserAppContext from '../hook/UserAppContext'

const Content = () => {

      const [home, setHome] = useState(true)
      const [relationship, setRelation] = useState(false)
      const [video, setVideo] = useState(false)
      const [gallery, setGallery] = useState(false)
      const [friend, setFriend] = useState(false)
      const [obj, setObj] = useState([])
      const [modal, setModal] = useState(false)
      const {user} = UserAppContext()

      if(user.length === 0) return

      const showPage = (page) => {

            if(page === 'home'){
                  setHome(true)
                  setFriend(false)
                  setGallery(false)
                  setRelation(false)
                  setVideo(false)
                  return
            }

            if(page === 'friend'){
                  setHome(false)
                  setFriend(true)
                  setGallery(false)
                  setRelation(false)
                  setVideo(false)
                  return
            }

            if(page === 'gallery'){
                  setHome(false)
                  setFriend(false)
                  setGallery(true)
                  setRelation(false)
                  setVideo(false)
                  return
            }

            if(page === 'relation'){
                  setHome(false)
                  setFriend(false)
                  setGallery(false)
                  setRelation(true)
                  setVideo(false)
                  return
            }

            if(page === 'video'){
                  setHome(false)
                  setFriend(false)
                  setGallery(false)
                  setRelation(false)
                  setVideo(true)
                  return
            }
            
      }


      return (
            <div className="content">
                  <div className="content_nav">
                        <div className="nav_menu">
                              <ul className="nav_menu__box">
                                    <li className={home ? "active" : ''}><button onClick={() => showPage('home')}><AiOutlineHome/></button></li>
                                    <li className={relationship ? "active" : ''}><button onClick={() => showPage('relation')}><AiOutlineHeart/></button></li>
                                    <li className={video ? "active" : ''}><button onClick={() => showPage('video')}><AiOutlineYoutube/></button></li>
                                    <li className={gallery ? "active" : ''}><button onClick={() => showPage('gallery')}><AiOutlineFileImage/></button></li>
                                    <li className={friend ? "active" : ''}><button onClick={() => showPage('friend')}><AiOutlineUsergroupAdd/></button></li>
                                    <li className={home ? "current home" : (relationship ? "current relation" : (video ? "current video" : (gallery ? "current gallery" : (friend ? "current friend" : "current"))))}></li>
                              </ul>
                        </div>
                        
                  </div>
                  <div className="pages">
                        <Home isHome={home} />
                        <Relation isRelation={relationship} />
                        <Video isVideo={video} />
                        <Gallery isGallery={gallery} isSetModal={setModal} isSetObj={setObj}/>
                        <Friend isFriend={friend} />
                  </div>
                  <Modal isModal={modal} isSetModal={setModal} isObj={obj}/>
            </div>
      )
}

export default Content
